import Input from "./Input";
import Eye from "../icons/Eye";
import Eyelock from "../icons/Eyelock";

// Used in Input Of Type Password Only..
const InputIcon = ({ show, setShow, language, t, ...props }) => {

  return (
    <div className="relative">
      <Input type={!show ? "password" : "text"} t={t} {...props} />
      <button
        type="button"
        className={`absolute top-[0.5rem] ${
          language === "en" ? "right-2" : "left-2"
        } text-zinc-400`}
        onClick={() => setShow(!show)}
      >
        {!show ? (
          <Eye className="size-[18px]" />
        ) : (
          <Eyelock className="size-[18px]" />
        )}
      </button>
    </div>
  );
};

export default InputIcon;
